import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  typography: {
    fontFamily: `Source Sans Pro`,
  },
  palette: {
    primary: {
      main: "#5C6369",
    },
    secondary: {
      main: "#20639B",
    },
    color_third: {
      main: "#DDB363",
    },
    color_fourth: {
      main: "#002D56",
    },
  },
});
export default theme;
